module.exports = __webpack_public_path__ + "static/media/personal.dd2f28f1.png";